import React from 'react';
import PropTypes from 'prop-types';
import { withStyles, makeStyles } from '@mui/styles';
import Slider from '@mui/material/Slider';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material//Tooltip';
import classes from './ccf-slider.module.scss';
import { Theme} from '@mui/material';


/* eslint-disable-next-line */
export interface CcfSliderProps {}

const useStyles = makeStyles((theme : Theme) => ({
  root: {
    width: '60%',
    margin: "0 10px"
  },
  margin: {
    height: theme.spacing(3),
  },
}));

const iOSBoxShadow =
  '0 3px 1px rgba(0,0,0,0.1),0 4px 8px rgba(0,0,0,0.13),0 0 0 1px rgba(0,0,0,0.02)';

const IOSSlider = withStyles({
  root: {
    height: 2,
    padding: '5px 0',
    background: 'linear-gradient(90deg, #2ad28b 30%, #F4732E 60%)',
    pointerEvents: 'none'
  },
  thumb: {
    height: 18,
    width: 18,
    backgroundColor: 'transparent',
    border: '4px solid #6d6e70',
    pointerEvents: 'none',
    marginTop: -9,
    marginLeft: -12,
    '&:focus, &:hover, &$active': {
      boxShadow: 'inherit',
    },
  },
  active: {},
  valueLabel: {
    left: 'calc(-50% + -6px)',
    top: 22,
    '& *': {
      background: 'transparent',
      font: 'normal normal 600 16px/18px Open Sans !important',
      color: '#7C96A3'
    },
  },
  track: {
    height: 0,
  },
  rail: {
    opacity: 1,
    height: 0,
  },
  mark: {
    backgroundColor: '#000',
    height: 8,
    width: 1,
    marginTop: -3,
  },
  markActive: {
    opacity: 1,
  },
})(Slider);


/**
 * linear gradient slider from react material slider
 * @param props - slider props
 * @example - <CcfSlider /> 
 */
export function CcfSlider(props: CcfSliderProps) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <IOSSlider aria-label="ios slider" min={0} max={4} defaultValue={0.35} valueLabelDisplay="on" />
    </div>
  );
}

export default CcfSlider;

